<template>
  <div class="all-data-stand">
    <div class="all-data__title">{{pageTitle}}</div>
    <page-tab :paramsLabel="'type'" :isParams="true" :nowTab="nowTab" :tabs="tabs"></page-tab>
    <filter-condition
      ref="filterCom"
      v-if="nowTab === '1' || $route.name === 'kehuData'"
      :fields="fields"
      :btnDisabled="btnDisabled"
      @filterConSearch="search"
      @toggleFilterShow="toggleFilterShow"
    ></filter-condition>
    <div class="action-table-box" :class="{'action-table-box_tip': !hasTip}">
      <!-- 页面的 添加数据 批量删除 批量还原操作集合-->
      <div class="data-page-actions" v-if="hasTip">
        <div class="select-total" v-if="pageName === 'kehuData' && pageType === '2'">已选 <span :class="{ 'yellow': selectTotal }">{{selectTotal}}</span> 条数据</div>
        <div class="select-total" v-else>共 <span :class="{ 'yellow': true }">{{ total || 0}}</span> 条数据</div>
        <div
          v-for="(act, index) in action" :key="index"
          class="link-btn"
          @click="actionClick(act)">
          <i class="yjh-icon iconfont" :class="act.icon"></i><span>{{act.name}}</span>
        </div>
      </div>
      <page-table
        ref="table"
        :loading="loading"
        :col="tableCol"
        :data="tableData"
        :pageSize="pageSize"
        :pageIndex="pageIndex"
        :total="total"
        :selectAll="selectAll"
        :selectChange="selectChange"
        @compFn="compFn"
        @pageChange="pageChange"
        @pageSizeChange="pageSizeChange"
        @selectChange="selectChange"
      ></page-table>
    </div>
    <deal-dialog
      :isShow="dealDiaShow"
      :dealType="dealType"
      :dialogTitle="dialogTitle"
      :dealSingleData="dealSingleData"
      @close="dialogClose"
      @confirm="delConfirm"
    ></deal-dialog>
    <!-- 转移并删除弹框 -->
    <trans-diag
      :isShow="transDiaShow"
      :oriData="transDiagData"
      :esName="esName"
      @close="transDiaShow = false"
      @confirm="transConfirm"
    ></trans-diag>
  </div>
</template>
<script>
import pageTab from '@/components/pageCom/pageTab.vue'
import pageTable from '@/components/pageCom/pageTable'
import filterCondition from './components/filterCondition'
import dealDialog from './components/dealDiag'
import transDiag from './components/transDiag'

import infosMixin from './components/infosMixin'

import { msg } from '@/utils/index'
import { delMaindata, reventMaindata } from '@/api/goodStand'
export default {
  name: 'allDataStand',
  components: {
    filterCondition,
    pageTab, pageTable, dealDialog, transDiag
  },
  mixins: [infosMixin],
  data() {
    return {
      nowTab: '1',
      fields: [],
      btnDisabled: false, // 查询按钮
      dealDiaShow: false,
      dealType: '', // 操作类型 1 删除 2 批量删除 3还原 4批量还原
      dialogTitle: '',
      dealSingleData: {},
      selectRowData: [],
      esName: '', // list的返回数据
      transDiaShow: false,
      transDiagData: [],
      isReventing: false, // 是否在还原中
      isDeling: false // 是否删除中
    }
  },
  computed: {
    action() { // 每一页的操作集合
      return this.actions[this.$route.params.type - 1] || []
    },
    selectTotal() { // 已经选中的数据
      return this.selectRowData.length
    },
    pageName() {
      return this.$route.name
    },
    pageType() {
      return this.$route.params.type
    },
    hasTip() { // 是否有已选提示
      const arr = ['doctorData', 'jiyaoData', 'guochanData', 'jinkouData', 'yibaoData']
      if (arr.includes(this.pageName)) {
        return false
      } else {
        return (this.pageName === 'kehuData' || this.pageType === '1')
      }
    }
  },
  methods: {
    search(params) { // 条件查询
      this.pageIndex = 1
      this.pageSize = 30
      this.getData(params)
    },
    selectAll(selection) {
      this.selectRowData = selection
    },
    selectChange(selection) {
      this.selectRowData = selection
    },
    compFn(params) {
      if (params.type === 'jiucuo') {
        this.$router.replace({
          name: 'fixData',
          params: {
            type: this.$route.name,
            id: params.rowData.row_id
          }
        })
      } else if (params.type === 'del') {
        // 20-08-06 这里是删除的操作
        this.dealType = '1'
        if (this.$route.name === 'companyData') { // 生产企业数据库直接删除
          this.dealSingleData = params.rowData
          this.dealDiaShow = true
        } else { // 非生产企业数据库 转移并删除
          const tmpData = params.rowData
          if (this.$route.name === 'shangyeData') { // 商业公司判断是不是关联清洗
            if (params.rowData.is_clean === '是') {
              tmpData.is_target = ''
              this.transDiagData = [tmpData]
              this.transDiaShow = true
            } else if (params.rowData.is_clean === '否') {
              this.dealSingleData = tmpData
              this.dealDiaShow = true
            }
          } else {
            if (params.rowData.is_clean === '是' || params.rowData.is_target === '是') {
              this.transDiagData = [tmpData]
              this.transDiaShow = true
            } else if (params.rowData.is_clean === '否' || params.rowData.is_target === '否') {
              this.dealSingleData = tmpData
              this.dealDiaShow = true
            }
          }
        }
      } else if (params.type === 'revent') {
        this.dealType = '3'
        this.dealSingleData = params.rowData
        this.dealDiaShow = true
      } else if (params.type === 'edit') {
        const routeData = this.$router.resolve({
          name: 'editData',
          params: {
            type: this.$route.name,
            id: params.rowData.id,
            tabType: this.$route.params.type
          }
        })
        window.open(routeData.href, '_blank')
      } else if (params.type === 'newapply') { // 新增审核 && 恢复审核
        this.$router.push({
          name: 'customDataCheck',
          params: {
            id: params.rowData.id,
            type: params.rowData.backend_check_status
          }
        })
      } else if (params.type === 'cus_jiu_apply') { // 主数据库纠错
        this.$router.push({
          name: 'customJiuCheck',
          params: {
            id: params.rowData.id
          }
        })
      } else if (params.type === 'cus_del_apply') { // 主数据库删除
        this.$router.push({
          name: 'customDelCheck',
          params: {
            id: params.rowData.id
          }
        })
      }
    },
    actionClick(act, index) {
      // 新增数据
      if (act.type === '1') {
        // 新打开页面
        const routeData = this.$router.resolve({
          name: 'addData',
          params: {
            type: this.$route.name,
            id: '1',
            tabType: this.$route.params.type
          }
        })
        window.open(routeData.href, '_blank')
      } else if (act.type === '2') {
        // 批量删除
        if (!this.selectRowData.length) {
          msg.call(this, '请选择需要操作的选项')
          return
        }
        this.dealType = '2'
        this.dealDiaShow = true
      } else if (act.type === '3') {
        // 批量还原
        if (!this.selectRowData.length) {
          msg.call(this, '请选择需要操作的选项')
          return
        }
        this.dealType = '4'
        this.dealDiaShow = true
      }
    },
    dialogClose() {
      this.dealDiaShow = false
    },
    delConfirm() {
      if (this.dealType === '1') { // 删除
        if (Number(this.dealSingleData.is_terminal) === 1) {
          this.$Message.info('已绑定目标，无法删除')
        } else {
          this.delData(this.dealSingleData.id)
        }
      } else if (this.dealType === '2') { // 批量删除
        this.delData(this.selectRowData.map(item => item.id).join(','))
      } else if (this.dealType === '3') { // 还原
        this.reventData(this.dealSingleData.id)
      } else if (this.dealType === '4') { // 批量还原
        this.reventData(this.selectRowData.map(item => item.id).join(','))
      }
    },
    // 删除和批量删除
    delData(ids) {
      if (this.isDeling) {
        return
      }
      this.isDeling = true
      delMaindata(ids, this.pageName).then(res => {
        this.isDeling = false
        if (res.code === 0) {
          this.dialogClose()
          msg.call(this, '删除成功')
          this.getRealData(this.templateParams)
        } else {
          msg.call(this, res.msg)
        }
      })
    },
    // 还原和批量还原
    reventData(id) {
      if (this.isReventing) {
        return
      }
      this.isReventing = true
      reventMaindata(id).then(res => {
        this.isReventing = false
        if (res.code === 0) {
          this.dialogClose()
          this.getRealData(this.templateParams)
        } else {
          msg.call(this, res.msg)
        }
      })
    },
    // 点击展开或者关闭 重置table高度
    toggleFilterShow() {
      this.$refs['table'].resize()
    },
    transConfirm() {
      this.transDiaShow = false
      this.getRealData()
    }
  }
}
</script>
<style lang="scss" scoped="">
  .link-btn > span {
    line-height: 16px;
  }
  /deep/ .v-checkbox-input {
    display: none;
  }
  /deep/ .v-table-title-cell {
    span {
      font-weight: 500;
    }
  }
</style>
<style lang="scss">
@import '@/styles/color.scss';
.all-data-stand {
  position: relative;
  .all-data__title {
    padding-top: 10px;
    font-size: 16px;
    font-weight: 600;
    color: $fontBlack;
  }
  .ivu-tabs-nav-wrap {
    margin-top: 24px;
  }
  // .ivu-tabs-tab { // 09-28这里为什么要加
  //   &:nth-child(2) {
  //     position: absolute;
  //     left: 150px;
  //   }
  // }
  .action-table-box {
    padding-top: 24px;
  }
  .action-table-box_tip {
    padding-top: 8px;
  }
  .data-page-actions {
    position: relative;
    padding: 0 0 16px 0;
    text-align: right;
    .select-total {
      position: absolute;
      color: #90A4B7;
    }
  }
  .table-title { // 封 0925-打包表格全选消失
    padding: 0px !important;
  }
}
</style>
